import { isEmpty } from 'lodash'
import { Fragment, useMemo } from 'react'

import { IProjectAttrs } from '../../project/types/project'
import CurriculumKlassTasks from './CurriculumKlassTasks'
import CurriculumNoticeCard from './CurriculumNoticeCard'
import CurriculumQnACard from './CurriculumQnACard'
import { INotice } from '../../note/types'
type ICurProject = IProjectAttrs & {
  isSubmitted: boolean
}
interface ICurriculumLMSSectionProps {
  curriculumId: string
  lmsMenu: {
    [key: string]: {
      id: string
      isVisible: boolean
    }
  }
  dashboardData: {
    notices: INotice[]
    qnas: any[]
    surveys: any[]
  }
  curProject: ICurProject | undefined
}

type ISection = {
  title: string
  menus: ('project' | 'survey' | 'notice' | 'qna')[]
  components: {
    project?: JSX.Element
    survey?: JSX.Element
    notice?: JSX.Element
    qna?: JSX.Element
  }
}

const CurriculumLMSSection = ({
  curriculumId,
  lmsMenu,
  dashboardData,
  curProject,
}: ICurriculumLMSSectionProps) => {
  const projectData = useMemo(() => {
    if (isEmpty(curProject)) {
      return {
        startedAt: '',
        endedAt: '',
        isSubmitted: true,
      }
    } else {
      return {
        startedAt: curProject?.startedAt,
        endedAt: curProject?.endedAt,
        isSubmitted: curProject?.isSubmitted,
      }
    }
  }, [curProject])

  const surveyData = useMemo(() => {
    if (isEmpty(dashboardData?.surveys[0])) {
      return {
        startedAt: '',
        endedAt: '',
        isSubmitted: true,
      }
    } else {
      return {
        startedAt: dashboardData?.surveys[0]?.startedAt,
        endedAt: dashboardData?.surveys[0]?.endedAt,
        isSubmitted: dashboardData?.surveys[0]?.isCompleted,
      }
    }
  }, [dashboardData])

  const sections: ISection[] = [
    {
      title: '강의 활동',
      menus: ['project', 'survey'],
      components: {
        project: (
          <CurriculumKlassTasks id="project" curriculumId={curriculumId} data={projectData} />
        ),
        survey: <CurriculumKlassTasks id="survey" curriculumId={curriculumId} data={surveyData} />,
      },
    },
    {
      title: '강의 자료실',
      menus: ['notice', 'qna'],
      components: {
        notice: <CurriculumNoticeCard curriculumId={curriculumId} data={dashboardData.notices} />,
        qna: <CurriculumQnACard curriculumId={curriculumId} data={dashboardData.qnas} />,
      },
    },
  ]

  return (
    <>
      {sections.map(
        ({ title, menus, components }) =>
          menus.some(menu => lmsMenu[menu].isVisible) && (
            <div key={title} className="flex flex-col gap-4 lg:gap-6">
              <h4 className="text-lg font-semibold text-label-normal lg:text-2xl">{title}</h4>
              <div
                className={
                  title === '강의 활동'
                    ? 'flex flex-col gap-3 md:flex-row md:flex-wrap md:gap-6'
                    : 'grid grid-cols-1 gap-3 md:gap-6 lg:grid-cols-2'
                }
              >
                {menus.map(
                  menu =>
                    lmsMenu[menu].isVisible && <Fragment key={menu}>{components[menu]}</Fragment>,
                )}
              </div>
            </div>
          ),
      )}
    </>
  )
}

export default CurriculumLMSSection
